module.exports = __webpack_public_path__ + "static/img/5.54e334a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/zh/5.png
// module id = BtoJ
// module chunks = 0